import { Typography } from '@euler/app/components/typography';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { PrimaryButton } from '../../../../../ai-suite/components/PrimaryButton';
import { aiColors } from '../../../../../ai-suite/theme';

/** 结束 asks once; an exam's 交卷 says it cannot be undone. */
export const StopSheet = memo(
  ({
    visible,
    exam,
    onClose,
    onConfirm,
  }: {
    visible: boolean;
    exam: boolean;
    onClose: () => void;
    onConfirm: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <BottomPanel visible={visible} onClose={onClose} fitContent>
        <View style={{ padding: rpx(20), gap: rpx(16) }}>
          <Typography.Text size={rpx(16)} bold color={aiColors.foreground}>
            {exam ? '确定交卷吗？' : '现在结束？'}
          </Typography.Text>
          <Typography.Text size={rpx(14)} color={aiColors.mutedForeground}>
            {exam ? '交卷后不能继续。' : '会根据目前的对话生成报告。'}
          </Typography.Text>
          <PrimaryButton
            title={exam ? '交卷' : '结束并看报告'}
            onPress={onConfirm}
          />
          <TouchableOpacity
            onPress={onClose}
            style={{ alignItems: 'center', paddingVertical: rpx(8) }}
          >
            <Typography.Text size={rpx(14)} color={aiColors.mutedForeground}>
              继续练
            </Typography.Text>
          </TouchableOpacity>
        </View>
      </BottomPanel>
    );
  },
);
